// extracted by mini-css-extract-plugin
export var readonly = "_h6-1";
export var star = "_h6-0";